import { Box, styled } from '@mui/material'

const NO_ROW_BORDER = {
    '& tbody td': {
        borderBottom: 'none',
    },
}

export const AlignedTableBox = styled(Box)({
    ...NO_ROW_BORDER,
    '& table': {
        tableLayout: 'fixed',
    },
})

export const AlignedHeadlessTableBox = styled(Box)({
    ...NO_ROW_BORDER,
    '& table': {
        tableLayout: 'fixed',
    },
    '& thead tr': {
        height: 0,
    },
    '& thead th': {
        height: 0,
        padding: 0,
        border: 0,
        lineHeight: 0,
        fontSize: 0,
        overflow: 'hidden',
    },
})
